const NO_PHOTOS_SRC =
	'/static/v9/media/images/widget-images/v1/no-photo-lrg.png';

export const NO_PHOTOS_IMAGE = {
	src: NO_PHOTOS_SRC,
	thumbnail: NO_PHOTOS_SRC
};
